// React bootstrap table next =>

import React, {useMemo} from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {Card} from 'react-bootstrap';
import paginationFactory, {PaginationProvider} from "react-bootstrap-table2-paginator";
import {sizePerPageList, defaultSorted, columns} from "./ui.helpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import {Pagination} from "../../../../_metronic/_partials/controls";
import {useSamplesUIContext} from "../../../contexts/SamplesUIContext";

export function SamplesTable(props) {
  const context = useSamplesUIContext();
  const {totalCount, sampleList, listLoading} = props;

  const {
    queryParams,
    setQueryParams,
    onClick,
  } = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
    onClick: (_, row) => context.openSampleDetailDialog(row.reqSeq),
  }), [context]);

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  return (
    <Card>
      <Card.Body>
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({paginationProps, paginationTableProps}) => (
            <Pagination isLoading={listLoading} paginationProps={paginationProps}>
              <BootstrapTable
                remote
                hover
                bootstrap4
                keyField="reqSeq"
                bordered={false}
                columns={columns}
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden table-responsible"
                data={sampleList === null ? [] : sampleList}
                defaultSorted={defaultSorted}
                noDataIndication={<NoRecordsFoundMessage entities={sampleList}/>}
                onTableChange={getHandlerTableChange(setQueryParams)}
                rowEvents={{onClick}}
                {...paginationTableProps}
              />
            </Pagination>
          )}
        </PaginationProvider>
      </Card.Body>
    </Card>
  );
}
